// extracted by mini-css-extract-plugin
module.exports = {"library":"styles_library__2jh8_"};